import { ChartColumn, ChartPie } from '@carbon/react/icons';
import { CHART_VARIANTS, ChartTypes } from '../types';
import { Button } from '@carbon/react';
import { FC } from 'react';

export interface ChartTypeSelectionProps {
  setChartType: (chartType: ChartTypes) => void;
}

const ChartTypeSelection: FC<ChartTypeSelectionProps> = ({ setChartType }) => {
  return (
    <div>
      <Button
        hasIconOnly
        iconDescription="Column Chart"
        size="sm"
        renderIcon={ChartColumn}
        kind="ghost"
        onClick={() => setChartType(CHART_VARIANTS.column)}
      ></Button>
      <Button
        hasIconOnly
        iconDescription="Pie Chart"
        size="sm"
        renderIcon={ChartPie}
        kind="ghost"
        onClick={() => setChartType(CHART_VARIANTS.pie)}
      ></Button>
    </div>
  );
};

export { ChartTypeSelection };
